export const API_BASE_URL = 'https://cors-anywhere.herokuapp.com/https://api.yelp.com/v3';

//FIXME: remove this token
export const BEARER_TOKEN = 'O4JNnGx9X1K4ob_XXNycmYmw6aRg_301eB8ZGT-l8wZhzEq3W81ar_ywxC7rORwlLydvMMt_uvk2U9ulR2CRRWzJixf6wAurUiDU_O7_J1awtjZxj3HwWybvLCWAX3Yx';

